@if (items && items.length>1) {
  <mat-form-field [ngClass]="cssClassName">
    @if (label?.length) {
      <mat-label>{{ label }}</mat-label>
    }
    <mat-select #select [formControl]="selectControl" [multiple]="multipleSelect">
      @if (multipleSelect) {
        <pub-select-all-none-buttons [allSelected]="allSelected" [singleSelected]="singleSelected"
        (toggleAll)="toggleAllSelection($event)"></pub-select-all-none-buttons>
      }
      <mat-select-trigger data-testid="trigger">{{ selectedText }}</mat-select-trigger>
      @if (!multipleSelect && allSelectedLabel) {
        <mat-option value=''>{{ allSelectedLabel }}</mat-option>
      }
      @for (item of items; track item) {
        <mat-option [value]="item.value"
          [disabled]="item.disabled">{{ item.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
